export const zoomInTooltipPosition = {
  BOTTOM_RIGHT: "BOTTOM_RIGHT",
  TOP_LEFT: "TOP_LEFT",
  TOP_RIGHT: "TOP_RIGHT",
};

export const zoomInTooltipPositionText = {
  BOTTOM_RIGHT: "Vpravo dole",
  TOP_LEFT: "Vlevo nahoře",
  TOP_RIGHT: "Vpravo nahoře",
};

export const zoomInTransition = {
  NORMAL: "NORMAL",
  ZOOM_TO_ZOOM: "ZOOM_TO_ZOOM",
};

export const zoomInTransitionText = {
  NORMAL: "Oddálit",
  ZOOM_TO_ZOOM: "Od jednoho k druhému",
};

export const screenTransition = {
  ON_TIME: "ON_TIME",
  ON_BUTTON: "ON_BUTTON",
};

export const screenTransitionText = {
  ON_TIME: "Po uplynutí času",
  ON_BUTTON: "Tlačítko pro přesun",
};



// WEBPACK FOOTER //
// ./src/enums/screenEnums.js